import request from '@/utils/request'

/** 门店端当前登录人档案（含门店 mdid） */
export function getMyProfile() {
  return request({
    url: '/api/Extend/LqStoreAuth/MyProfile',
    method: 'get'
  })
}
